import { templateService } from '../services';

const state = {
  templates: [],
  totalCount: 0,
  search: {
    pageRows: 10,
    actualPage: 1,
    orderBy: '',
    orderByAsc: false
  }
};

const actions = {
  getAll({ dispatch, commit }: any) {
    templateService
      .getAll()
      .then(
        templates => commit('getAllSuccess', templates),
        error => console.log(error)
      )
      .finally();
  },
  getById({ commit }: any, id: any) {
    return templateService
      .getById(id)
      .then(
        template => {
          return template;
        },
        error => console.log(error)
      )
      .finally();
  },
  create({ dispatch }: any, { template }: any) {
    templateService
      .create(template)
      .then(
        () => {
          dispatch('alert/success', 'template.created', {
            root: true
          });
        },
        error => {
          dispatch('alert/error', JSON.stringify(error), {
            root: true
          });
        }
      )
      .finally(() => dispatch('getAll'));
  },
  update({ dispatch }: any, { id, template }: any) {
    templateService
      .update(id, template)
      .then(
        () => {
          dispatch('alert/success', 'template.updated', {
            root: true
          });
        },
        error => {
          dispatch('alert/error', JSON.stringify(error), {
            root: true
          });
        }
      )
      .finally(() => dispatch('getAll'));
  },
  delete({ dispatch }: any, { id }: any) {
    templateService
      .deleteTemplate(id)
      .then(
        () => {
          dispatch('alert/success', 'template.deleted', {
            root: true
          });
        },
        error => {
          dispatch('alert/error', JSON.stringify(error), {
            root: true
          });
        }
      )
      .finally(() => dispatch('getAll'));
  }
};

const mutations = {
  getAllSuccess(state: any, templates: any) {
    state.templates = templates;
  }
};

const getters = {
  getTemplates: (state: any, getters: any) => () => {
    return state.templates;
  }
};

export const template = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
